/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2023] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import GridView from '@/views/GridView';
import StringCell from '@/backgrid/StringCell';
import PageableCollection from '@/backbone/PageableCollection';
import ButtonCell from '@/backgrid/ButtonCell';

import UpdateAssetProblemStatus from '../../services/UpdateAssetProblemStatus';

const LoggedProblemsGridView = GridView.extend({
  options: {
    pageSize: 20
  },

  initialize() {
    const self = this;

    this.options.columns = [
      {
        name: 'contractNumber',
        label: 'Contract #',
        cell: StringCell,
        headerCell: 'custom',
        width: 10,
        editable: false
      },
      {
        name: 'serialNumber',
        label: 'Serial #',
        cell: StringCell,
        headerCell: 'custom',
        width: 7,
        editable: false
      },
      {
        name: 'description',
        label: 'Description',
        cell: StringCell,
        headerCell: 'custom',
        width: 35,
        editable: false
      },
      {
        name: 'createdOn',
        label: 'Created On',
        cell: StringCell,
        headerCell: 'custom',
        width: 7,
        editable: false
      },
      {
        name: 'problemStatus',
        label: 'Status',
        cell: StringCell,
        headerCell: 'custom',
        width: 5,
        editable: false
      },
      {
        name: 'resolveReopenButton',
        label: '',
        width: 5,
        headerCell: 'custom',
        cell: ButtonCell.extend({
          name() {
            return this.model.get('statusId') === '1' ? 'Resolve' : 'Reopen';
          },
          onClick(e, model) {
            self.onClickUpdateStatus(e, model);
          },
          buttonClass() {
            return this.model.get('statusId') === '1'
              ? 'btn-sm btn-outline-success'
              : 'btn-sm btn-outline-primary text-white-hover';
          }
        }),
        editable: false,
        sortable: false
      }
    ];
    this.collection = new PageableCollection([], {
      pageSize: this.options.pageSize
    });
    this.options.emptyText = 'No Problems Found';
    GridView.prototype.initialize?.apply(this, this.options);
  },

  async onClickUpdateStatus(e, model) {
    e?.preventDefault();
    const id = model.get('id');
    const statusId = model.get('statusId');

    await UpdateAssetProblemStatus(id, statusId);
    model.set('statusId', model.get('statusId') === '1' ? '2' : '1');
    model.set('problemStatus', model.get('statusId') === '1' ? 'Open' : 'Resolved');

    this.triggerMethod('status:updated');
  }
});
export default LoggedProblemsGridView;
